
import React, {Component} from 'react';
import { NavLink } from 'react-router-dom';


export default class SignInUpNav extends Component {
  render(){
    return(
      <nav className="navbar navbar-expand-sm navbar-light">
        <ul className="navbar-nav container">
          <li className="nav-item">
            <NavLink className="nav-link sign-nav" activeClassName="active" exact to="/home">Sign Up</NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link sign-nav" activeClassName="active" exact to="/home/login">Sign In</NavLink>
          </li>
        </ul>
      </nav>
    )
  }
}